import { BaseDto } from "src/dtos/common/baseDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface EquipmentDto extends BaseDto {

	equipmentCd: string;				// 설비코드(기본키)
	equipmentNm: string;				// 설비명
	equipmentSpec: string;				// 설비규격
	eqmSerial: string;					// 시리얼번호 < 일련번호호
	equipmentType: string;				// 설비유형/EQMTYPE
	workplaceCd: string;				// 사용공정/workplace_cd
	equipmentSeq: number;				// 설비순번(호)
	displaySeq: number;					// 조회순서
	compCd: string;						// 사업장코드
	compNm: string;						// 사업장명
	eqmOrgcd: string;					// 담당부서/DEPCD
	eqmOrgNm: string;					// 담당부서명
	eqmPerson: string;					// 담당자/emp_no
	eqmPersonNm: string;				// 담당자명/emp_nm
	eqmPower: number;					// 전력/전략(KW)
	eqmVolt: number;					// 사용전류(V)
	sizeHeight: number;					// 높이
	sizeWidth: number;					// 넓이
	sizeDepth: number;					// 중량
	sizeWeight: number;					// 깊이
	otherSpec: string;					// 기타 규격
	manufacturerNm: string;				// 제조처
	manufactureDt: string | undefined;	// 제조일자
	purchaseNm: string;					// 구매처
	purchaseDt: string | undefined;		// 구매일
	purchaseAmt: number;				// 구매금액
	linkIp: string;						// IP주소
	linkPort: string;					// PORT
	gatheringCycle: number;				// 수집주기
	instrucTag: string;					// 작업지시여부
	virtualEqm: string;					// 가상설비여부
	eqmImage: string;					// 설비사진
	eqmImage2: string;					// 설비사진2
	eqmStatus: string;					// 설비상태
	eqmStatusNm: string;				// 설비상태명
	disposalDt: string | undefined;		// 폐기일자
	remark: string;						// 비고

	inserted: boolean;
	isModified: boolean;
	
}



//기본 인터페이스스
export const defaultEquipment: EquipmentDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	equipmentCd: '',
	equipmentNm: '',
	equipmentSpec: '',
	eqmSerial: '',
	equipmentType: '',
	workplaceCd: '',
	equipmentSeq: 0,
	displaySeq: 0,
	compCd: '',
	compNm: '',	
	eqmOrgcd: '',
	eqmOrgNm: '',
	eqmPerson: '',
	eqmPersonNm: '',
	eqmPower: 0,
	eqmVolt: 0,
	sizeHeight: 0,
	sizeWidth: 0,
	sizeDepth: 0,
	sizeWeight: 0,
	otherSpec: '',
	manufacturerNm: '',
	manufactureDt: formatDate(new Date()),
	purchaseNm: '',
	purchaseDt: formatDate(new Date()),
	purchaseAmt: 0,
	linkIp: '',
	linkPort: '',
	gatheringCycle: 0,
	instrucTag: '',
	virtualEqm: '',
	eqmImage: '',
	eqmImage2: '',
	eqmStatus: '',
	eqmStatusNm: '',
	disposalDt: formatDate(new Date()),
	remark: '',

	inserted: false,
	isModified: false,
}
